

































































































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import AMSDialog from '@/components/AMSDialog.vue';
import { getOperations, accountHistories, getOpertaionName, accountHistoryDetail, accountUndo } from '@/api/customer';
import AMSPagination, { PaginationModel } from '@/components/AMSPagination.vue';
import AMSStaffSelector from '@/components/AMSStaffSelector.vue';
import { systemeAccount } from '@/api/system';
import { AppStore } from '../../store/modules/app';
import AMSImg from '@/components/AMSImg.vue';
import { emptyRule } from '../../utils/rules';
import Utils from '../../utils/utils';
import { allStaff } from '@/api/staff';
import moment from 'moment';

@Component({
  components: {
    'ams-dialog': AMSDialog,
    'ams-pagination': AMSPagination,
    'ams-staff-selector': AMSStaffSelector,
    'ams-img': AMSImg
  }
})
export default class IncomeExpenditureDetail extends Vue {
  /**销售 美导 */
  activeItems: any[] = [{ value: '', text: '全部' }];
  isLoadingAccount: boolean = false;
  accountMenuVisible: boolean = false;
  /**面包屑 */
  breadItems = [
    {
      text: '财务管理',
      disabled: false,
      href: 'incomeExpenditureDetail'
    },
    {
      text: '收支明细',
      disabled: true
    }
  ];
  // modal-loading
  requestLoading: boolean = false;
  /**类型选择器 */
  accountTypeMenu: boolean = false;
  /**开始时间选择器 */
  startTimeMenu: boolean = false;
  /**结束时间选择器 */
  endTimeMenu: boolean = false;
  /**显示隐藏详情弹窗 */
  showInfoDialog: boolean = false;
  /**显示隐藏确认弹窗 */
  showConfirmDialog: boolean = false;
  /**当前选中的客户 */
  selectAccount: any = null;
  totalCount: number = 0;
  headers: object[] = [
    { text: '单号', align: 'left', sortable: false, width: '200px' },
    { text: '操作日期', align: 'left', sortable: false, width: '150px' },
    { text: '类型', align: 'left', value: 'publishAt', sortable: false, width: '100px' },
    { text: '资金账户', align: 'left', sortable: false, width: '120px' },
    { text: '金额', align: 'right', sortable: false, width: '100px' },
    { text: '账户冻结金额', align: 'right', sortable: false, width: '120px' },
    { text: '账户余额', align: 'right', sortable: false, width: '100px' },
    { text: '操作', align: 'center', sortable: false, width: '100px' }
  ];
  paging: PaginationModel = {
    descending: false,
    page: 0,
    rowsPerPage: 10, // -1 for All",
    totalItems: 0,
    pageSizes: [10, 20, 30, 40],
    sortBy: ''
  };
  datas: any[] = [];
  sortStr: string = '';

  /**类型 */
  accountTypes: any[] = [
    { name: '全部', key: '' },
    ...getOperations
    // { name: '充值', key: 'Recharge' },
    // { name: '付款', key: 'Payment' },
    // { name: '撤销充值', key: 'UndoRecharge' },
    // { name: '转账', key: 'Transfer' }
  ];
  /**选中的类型 */
  accountType: any = null;
  /**资金账户 */
  accounts: any[] = [];
  /**选中资金账户 */
  account: any = null;

  /**选中的销售员 */
  sale: any = ''; //null;
  /**选中的美导 */
  guider: any = ''; //null;

  /**当前时间 */
  currentTime: string = new Date().toISOString().substr(0, 10);
  /**筛选条件 */
  customerFilter: string = '';
  operateStartTime: string = '';
  operateEndTime: string = '';
  saleId: string = '';
  operateType: string = '';
  accountId: string = '';
  beautyAdvisorId: string = '';
  customerId: string = '';

  /**点前选中的某一个单 */
  order: any = null;
  /**撤销原因 */
  undoReason: string = '';
  /**资金账户显示名称 */
  accountName: string = '全部';
  /**类型显示名称 */
  accountTypeName: string = '全部';

  onCustomerFilterClear() {
    this.selectAccount = null;
  }
  formatDate(date: Date) {
    return moment(date).format('YYYY-MM-DD');
  }
  formatDateTime(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }
  @Watch('customerFilter', { immediate: true, deep: true })
  onCustomerFilterChange(newValue: string, oldValue: string) {
    if (newValue === '' && newValue !== oldValue) {
      this.selectAccount = null;
    }
  }

  @Watch('accountTypeMenu', { immediate: true, deep: true })
  onAccountTypeMenuChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.accountTypeText as any;
    // console.log(text);
    if (text && newValue == false) {
      text.focus();
    }
  }

  onEnter() {
    this.$refs.BeginTimeText && (this.$refs.BeginTimeText as any).blur();
    this.$refs.EndTimeText && (this.$refs.EndTimeText as any).blur();
    this.$refs.accountTypeText && (this.$refs.accountTypeText as any).blur();
    this.$refs.accountMenuText && (this.$refs.accountMenuText as any).blur();
  }

  @Watch('startTimeMenu', { immediate: true, deep: true })
  onBeginTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.BeginTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  @Watch('endTimeMenu', { immediate: true, deep: true })
  onEndTimeChange(newValue: boolean, oldValue: boolean) {
    const text = this.$refs.EndTimeText as any;
    if (text && newValue == false) {
      text.focus();
    }
  }

  /**获取销售 美导*/
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.activeItems = [{ value: '', text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  /**点击了清空按钮 */
  onClearClick() {
    this.selectAccount = null;
    this.customerFilter = '';
    this.operateStartTime = '';
    this.operateEndTime = '';
    this.accountType = this.accountTypes[0];
    this.account = this.accounts[0];
    this.sale = '';
    this.guider = '';
    this.accountTypeName = '全部';
    this.accountName = '全部';
    // (this.$refs.saleSelector as any).reset();
    // (this.$refs.guiderSelector as any).reset();
  }

  /**详情弹窗 标题 */
  getInfoDialogTitle(order: any) {
    if (!order) return '';
    const head = `单号${order.number}`;
    if (order.operateType == 'Recharge' && !order.canUndo) {
      return `${head}(已撤销)`;
    } else {
      return head;
    }
  }
  /**详情弹窗 是否撤销原因 */
  getShowUndoButton(order: any) {
    if (!order) return true;
    if (this.getPermission('FinanceManager.RechargeList.UndoRecharge')) {
      return !order.canUndo;
    } else {
      return true;
    }
  }
  /**详情弹窗 是否撤销原因 */
  getShowUndoReason(type: string) {
    //撤消充值
    return type == 'UndoRecharge' ? true : false;
  }
  /**详情弹窗 是否显示附件 */
  getShowAttchment(type: string) {
    //充值
    return type == 'Recharge' ? true : false;
  }
  getShowType(type: string) {
    return type === 'Recharge' || type === 'UndoRecharge';
  }
  /**详情弹窗 时间 显示的标题 */
  getTimeTitle(type: string) {
    switch (type) {
      case 'Recharge': /// 充值
      case 'FreezeDifference': /// 冻结金额差值
      case 'OrderFreeze': /// 下单冻结
        return '创建时间';

      case 'CancelDedut': /// 取消扣款
      case 'UndoRecharge': /// 撤消充值
        return '撤销时间';

      case 'CancelFreeze': /// 取消冻结
      case 'Deduct': /// 扣款
        return '扣款时间';
      default:
        //Transfer 转账
        return '创建时间';
    }
    return '创建时间';
  }

  get enableSubmitButton() {
    return this.undoReason != '' && this.undoReason.length <= 50;
  }

  /**撤销原因规则 */
  get undoReasonRules() {
    if (this.undoReason == '') {
      return [emptyRule('撤销原因')];
    } else {
      return [];
    }
  }

  created() {}

  mounted() {
    if (this.$route.query.item) {
      this.selectAccount = this.$route.query.item;
      this.customerFilter = this.selectAccount.name;
    }
    this.accountType = this.accountTypes[0];
    this.account = { id: '', name: '全部' };
    this.getDetailList();
    this.getStaff();
  }

  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  /**点击弹框的取消 */
  closeAMSDialog(type: string) {
    switch (type) {
      case 'cancle':
        this.showInfoDialog = false;
        break;
      case 'confirm':
        this.undoReason = '';
        (this.$refs.undoReasonForm as any).resetValidation();
        this.showConfirmDialog = false;
        break;
      default:
        break;
    }
  }

  /**点击弹框的确定 */
  submitAMSDialog(stop: Function, type: string) {
    switch (type) {
      case 'cancle':
        if (this.order && this.order.customer && this.order.customer.isActive == true) {
          this.showConfirmDialog = true;
          (this.$refs.undoReasonForm as any).resetValidation();
        } else {
          AppStore.ShowError('该用户已被禁用，无法撤销充值');
        }
        break;
      case 'confirm':
        if ((this.$refs.undoReasonForm as any).validate()) {
          this.requestLoading = true;
          const params = {
            id: this.order.id,
            reason: this.undoReason
          };
          accountUndo(params)
            .then(response => {
              this.showConfirmDialog = false;
              this.showInfoDialog = false;
              this.undoReason = '';
              AppStore.ShowSuccess('撤销充值成功');
              this.onClearClick();
              this.getDetailList();
            })
            .finally(() => {
              stop();
              this.requestLoading = false;
            })
            .catch(error => {
              stop();
              AppStore.ShowError(error.error.message);
            });
        } else {
          stop();
        }
        break;
      default:
        break;
    }
  }

  /**点击了搜索按钮 */
  onSearch() {
    this.paging.page = 0;
    this.getDetailList(this.getParam());
    // if (this.selectAccount) {
    //   this.customerFilter = '';
    //   this.selectAccount = null;
    // }
  }

  getParam() {
    let parmas = {
      customerFilter: this.customerFilter,
      operateStartTime: moment(this.operateStartTime).toISOString(),
      operateEndTime: moment(this.operateEndTime).toISOString(),
      saleId: this.sale, //this.sale ? this.sale.id : '',
      operateType: this.accountType ? this.accountType.key : '',
      accountId: this.account ? this.account.id : '',
      beautyAdvisorId: this.guider //this.guider ? this.guider.id : ''
    };
    return parmas;
  }

  onPageChange(page: number) {
    this.paging.page = page;
    this.getDetailList(this.getParam());
  }

  onPageSizeChange(size: number) {
    this.paging.rowsPerPage = size;
    this.getDetailList(this.getParam());
  }

  /**获取收支明细列表 */
  getDetailList(formData?: any) {
    const _this = this;
    var params = {
      SkipCount: _this.paging.page * _this.paging.rowsPerPage, //当前页
      MaxResultCount: _this.paging.rowsPerPage, //每页大小
      Sorting: _this.sortStr,
      customerId: this.selectAccount ? this.selectAccount.id : ''
    };
    if (formData) {
      params = {
        ...params,
        ...formData
      };
    }

    accountHistories(params)
      .then((response: any) => {
        _this.totalCount = response.totalCount;
        _this.paging.totalItems = response.totalCount;

        _this.datas = response.items;
        _this.datas.map(v => {
          //yyyy-MM-dd hh:mm:ss
          v.operateTime = _this.dateFtt('yyyy-MM-dd', new Date(v.operateTime));
          v.operateName = getOpertaionName(v.operateType);
          v.amountDisplay = Utils.formatCurrencyPrice(v.amount);
          v.amountDisplay = parseFloat(v.amount) < 0 ? v.amountDisplay : `+${v.amountDisplay}`;
          v.freezeAmount = Utils.formatCurrencyPrice(v.freezeAmount);
          v.balance = Utils.formatCurrencyPrice(v.balance);
        });
      })
      .catch(error => {});
  }

  dateFtt(fmt: string, date: Date) {
    //author: meizz
    var o: { [key: string]: any } = {
      'M+': date.getMonth() + 1, //月份
      'd+': date.getDate(), //日
      'h+': date.getHours(), //小时
      'm+': date.getMinutes(), //分
      's+': date.getSeconds(), //秒
      'q+': Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    return fmt;
  }

  /**选中了某个充值账户 */
  onAccountTypeClick(v: any, i: any) {
    this.accountType = v;
    this.accountTypeName = v.name;
  }

  // /**类型显示名称 */
  // get accountTypeName() {
  //   return this.accountType ? this.accountType.name : '';
  // }

  // /**资金账户显示名称 */
  // get accountName() {
  //   return this.account ? this.account.name : '';
  // }

  /**获取资金账户 */
  getSystemAccount() {
    this.isLoadingAccount = true;
    systemeAccount()
      .then((response: any) => {
        this.isLoadingAccount = false;
        this.accounts = response.items;
        this.accounts.unshift({ id: '', name: '全部' });
      })
      .catch(error => {
        this.isLoadingAccount = false;
        AppStore.ShowError(error);
      });
  }

  @Watch('accountMenuVisible', { immediate: true, deep: true })
  onAccountMenuVisibleChange(value: any, oldValue: any) {
    if (value == true) {
      this.accounts = [];
      this.getSystemAccount();
    }

    const text = this.$refs.accountMenuText as any;
    // console.log(text);
    if (text && value == false) {
      text.focus();
    }
  }

  /**选中了某一项的详细 */
  onDetailClick(item: any) {
    if (item && item.id && item.id != '') {
      accountHistoryDetail(item.id)
        .then(response => {
          this.order = response;
          this.order.creationTime = this.dateFtt('yyyy-MM-dd hh:mm:ss', new Date(this.order.creationTime));
          this.order.operateName = getOpertaionName(this.order.operateType);
          this.order.showUndoReason = this.order.operateType == 'UndoRecharge';
          if (this.order.customer && this.order.customer.sales) this.order.salesStr = this.getNamesStrByList(this.order.customer.sales);
          if (this.order.customer && this.order.customer.beautyAdvisors) this.order.beautyAdvisorsStr = this.getNamesStrByList(this.order.customer.beautyAdvisors);

          this.order.amountDisplay = Utils.formatCurrencyPrice(this.order.amount);
          this.order.amountDisplay = parseFloat(this.order.amount) < 0 ? this.order.amountDisplay : `+${this.order.amountDisplay}`;
          this.order.freezeAmount = Utils.formatCurrencyPrice(this.order.freezeAmount);
          this.order.balance = Utils.formatCurrencyPrice(this.order.balance);

          this.showInfoDialog = true;
        })
        .catch(error => {
          AppStore.ShowError(error);
        });
    }
  }

  getNamesStrByList(items: any) {
    if (!items) {
      return '';
    }
    if (items.length <= 0) {
      return '';
    }
    let str = '';
    items.map((v: any) => {
      if (v.staff && v.staff.name) {
        str = v.staff.name + ',' + str;
      }
    });
    str = str.substring(0, str.length - 1);
    return str;
  }

  /**选中了某个资金账户 */
  onAccountClick(v: any, i: any) {
    this.account = v;
    this.accountName = v.name;
  }

  onSaleClear() {
    setTimeout(() => {
      this.sale = '';
    }, 1);
  }

  onGuiderClear() {
    setTimeout(() => {
      this.guider = '';
    }, 1);
  }

  onAccountClear() {
    setTimeout(() => {
      this.account = null;
      this.accountName = '全部';
    }, 1);
  }

  onTypeClear() {
    setTimeout(() => {
      this.accountType = null;
      this.accountTypeName = '全部';
    }, 1);
  }
  // 充值类型枚举
  switchRechargeTypes(type: string) {
    switch (type) {
      case 'Recharge':
        return '充值';
      case 'ChangeBalance':
        return '余额变更';
      default:
        return '';
    }
  }
}
